export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export const LOGIN_USER_CLEAN_STATE = 'LOGIN_USER_CLEAN_STATE';

export const LOGIN_SEND_VERIFY_EMAIL = 'LOGIN_SEND_VERIFY_EMAIL';